<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab"></b-card-header>
      <b-card-body>
        <div>
            <div class="col-md-4 mx-auto">
              <div>
                <div v-show="this.result" class="content_success">
                 	<div style="height:20px;">&nbsp;</div>
                   <lottie-animation path="animations/success.json"/>
                    <div class="text-center">
                      <h3 class="green_ok" style="color:#2dce89"> {{this.alert}} </h3>	
                      <a href="/DashBoard" class="btn active btnVolver" role="button" aria-pressed="true">Volver</a>
                       </div> 
                </div>
                <div v-show="!this.result" class="content_error">
                                    <div style="height:20px;">&nbsp;</div>
                                    <lottie-animation path="animations/error.json"/>
                      <div class="text-center">
                    <a href="/DashBoard" class="btn active btnVolver" role="button" aria-pressed="true">Volver</a>
                    </div> 
                  <br />
                  <br />
                </div>
              </div>
            </div>
        </div>
      </b-card-body>
    </b-card>
  </div>

</template>


<style type="text/css">
body {
  background: #f2f2f2;
}

.check {
  margin: 0px auto;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background: #fff;
  text-align: center;
}
.btnVolver:hover {
    background: rgba(201,57,98,1);
    color: #fff;
    text-decoration: none;
}
.btnVolver {
    background: rgba(255,88,85,1);
    padding: 10px;
    border-radius: 5px;
    color: #fff;
    text-decoration: none;
    margin-top: 20px;
    margin-bottom: 20px;
}
.check i {
  vertical-align: middle;
  line-height: 50px;
  font-size: 30px;
}

.content {
  text-align: center;
}

.content h1 {
  font-size: 25px;
  padding-top: 25px;
}

.content a:hover {
  text-decoration: none;
  background: #000;
}
h1, h2, h3, h4, h5
{
	color: #ff4940;
}

a
{
	color: #ff4940;
}

a:hover
{
	color: #c93961;
}

.tcpanel
{
	padding: 20px;	
	background-color: #f9f9f9;
}

.rscolor
{
	color: #ff4940;
}

.footer {
  background-color: #f5f5f5;
}

main
{
	margin-top:60px;
}

.logo
{
	max-height: 40px;
}

.rsgradient
{
	background: rgba(255,88,85,1);
	background: -moz-linear-gradient(top, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	background: -webkit-linear-gradient(top, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	background: -o-linear-gradient(top, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	background: -ms-linear-gradient(top, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	background: linear-gradient(to bottom, rgba(255,88,85,1) 0%, rgba(201,57,98,1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff5855', endColorstr='#c93962', GradientType=0 );
}
</style>

<script>
import Vue from "vue";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";


export default {
  components: {"lottie-animation":LottieAnimation},
  props: {
    result: Boolean,
    alert: String
  },
  data() {
    return {};
  },

  methods: {},
  beforeMount: function() {}
};
</script>